import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/feature-flags/page';

export const Route = createFileRoute('/_app/settings/feature-flags/')({
  component: Page,
});
